import React from "react";
import ReactDOM from "react-dom";
import { airbrake } from "../airbrake";
import { StyleItems, StyleItemsProps } from "../../common/components/StyleItems";

airbrake.call(() => {
  const preloadedProps: StyleItemsProps = (window as any).__PRELOADED_PROPS_SIMILAR_STYLES__;

  ReactDOM.hydrate(<StyleItems {...preloadedProps} />, document.getElementById("root-style-items"));
});
